import classNames from 'classnames'
import { ErrorMessage, Field } from 'formik'
import React, { InputHTMLAttributes } from 'react'
import { FlexColumn } from '../Containers'
import styles from './Checkbox.module.scss'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name?: string
  className?: string
  isFormik?: boolean
}

export const Checkbox: React.FC<Props> = ({
  name,
  className,
  isFormik = true,
  children,
  ...props
}) => {
  return isFormik ? (
    <FlexColumn gap="5px">
      <Field name={name}>
        {({ field }) => (
          <label className={classNames(className, styles.checkboxLabel)}>
            <input
              {...field}
              {...props}
              className={styles.checkboxInput}
              type="checkbox"
              checked={field.value || false}
              value={field.value}
            />
            <span
              role="checkbox"
              aria-checked={field.value}
              className={styles.checkboxControl}
            />
            <span className={styles.checkboxText}>{children}</span>
          </label>
        )}
      </Field>

      <ErrorMessage className="error" name={name} component="span" />
    </FlexColumn>
  ) : (
    <label className={classNames(className, styles.checkboxLabel)}>
      <input
        className={styles.checkboxInput}
        type="checkbox"
        name={name}
        {...props}
      />
      <span
        role="checkbox"
        aria-checked={props.checked}
        className={styles.checkboxControl}
      />
      <span className={styles.checkboxText}>{children}</span>
    </label>
  )
}
